import { GuestFacingUpgradeService, RTKUtils } from '@sevenrooms/api'
import type { GuestFacingUpgrade } from '@sevenrooms/domain'
import { baseReservationWidgetApi } from './BaseReservationWidgetApi'

interface VenueUpgrade {
  upgrade: GuestFacingUpgrade | undefined
  error: string | undefined
  isFetching: boolean
}

export interface VenuesUpgrade {
  [id: string]: VenueUpgrade
}

export const guestFacingUpgradeApi = baseReservationWidgetApi.injectEndpoints({
  endpoints: builder => ({
    getGuestFacingUpgrade: builder.query<GuestFacingUpgrade, string>({
      queryFn: RTKUtils.rtkQuery(GuestFacingUpgradeService.getGuestFacingUpgrades),
    }),
    getVenuesGuestFacingUpgrade: builder.query<VenuesUpgrade, { venueIds: string[] }>({
      async queryFn(_arg, _api, _extraOptions) {
        const { venueIds } = _arg
        const response = Object.fromEntries(venueIds.map(id => [id, { upgrade: undefined, error: undefined, isFetching: true }]))

        // this is necessary for initialization cache for getVenuesGuestFacingUpgrade query
        _api.dispatch(
          guestFacingUpgradeApi.util.updateQueryData('getVenuesGuestFacingUpgrade', _arg, data => {
            if (!data) {
              return response
            }
            return { ...data }
          })
        )
        Promise.all(
          venueIds.map(async id => {
            const venueUpgrades: VenueUpgrade = { upgrade: undefined, error: undefined, isFetching: true }
            try {
              venueUpgrades.upgrade = await GuestFacingUpgradeService.getGuestFacingUpgrades(id)
            } catch (e) {
              venueUpgrades.error = e as string
            } finally {
              venueUpgrades.isFetching = false
            }
            _api.dispatch(
              guestFacingUpgradeApi.util.updateQueryData('getVenuesGuestFacingUpgrade', _arg, draft => ({ ...draft, [id]: venueUpgrades }))
            )
          })
        )

        return { data: response }
      },
    }),
  }),
})

export const { useGetGuestFacingUpgradeQuery, useGetVenuesGuestFacingUpgradeQuery } = guestFacingUpgradeApi
